module.exports = __webpack_public_path__ + "bundles/EventSubmission/assets/images/icons/list-cfa30da39237c5494a829b34c29c08c1.svg";


//////////////////
// WEBPACK FOOTER
// ./app/client/bundles/EventSubmission/assets/images/icons/list.svg
// module id = 616
// module chunks = 0